import { gql } from "apollo-boost";
import {TEACHER_NAME_FIELDS} from '@/queries/fragments/name-fields';

export const GET_COURSEOUTLINE = gql`
  query getCourseOutline($id: ID!) {
    getCourseOutline(
      id: $id
    ) {
      id subjectCode teacherCode totalPoint instruction streamIntroPath bookName1 picturePath verticalPicturePath
      bookPic1 bookDescription1 bookName2 bookPic2 bookDescription2 bookName3 bookPic3 bookDescription3
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng creditCalGrade creditDesc
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      courseOutlineUnits {
        id seq nameLocal nameEng descriptionLocal descriptionEng preTestExpectScore
        postTestExpectScore unitAgenda unitObjective unitReference countLearnPercent
        mustLearnPrevious previousPercentRequireBeforeLearn
      }
      courseOutlineAssessments {
        id seq percent score
        assessment{
          id nameLocal nameEng
        }
      }
      vdoSets {
        id code description totalVdoLength
        vdoSetUnits {
          id unitSeq code totalVdoLength status remark
          courseOutlineUnit{ id nameLocal nameEng}
          vdoSetTopics {
            id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark
            playbackUrl
            playbackStatus
            videoProvider
            bunnyVideoGuid
            bunnyStatus
          }
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const GET_COURSEOUTLINE_BY_CLASS_SECTION = gql`
  query getCourseOutlinesByClassSection($id: ID!) {
    getCourseOutlinesByClassSection(
      id: $id
    ) {
      id subjectCode teacherCode totalPoint instruction streamIntroPath bookName1 picturePath verticalPicturePath
      bookPic1 bookDescription1 bookName2 bookPic2 bookDescription2 bookName3 bookPic3 bookDescription3
      courseOutlineUnits {
        id seq nameLocal nameEng descriptionLocal descriptionEng preTestExpectScore
        postTestExpectScore unitAgenda unitObjective unitReference
      }
#      courseOutlineAssessments {
#        id seq percent score
#        assessment{
#          id nameLocal nameEng
#        }
#      }
    }
  }
`;

export const GET_COURSEOUTLINES = gql`
  query getCourseOutlines {
    getCourseOutlines {
      id subjectCode teacherCode totalPoint instruction streamIntroPath bookName1 picturePath verticalPicturePath
      bookPic1 bookDescription1 bookName2 bookPic2 bookDescription2 bookName3 bookPic3 bookDescription3
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      courseOutlineAssessments {
        id seq percent score
        assessment{
          id nameLocal nameEng
        }
      }
      vdoSets {
        id code description totalVdoLength
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const GET_COURSEOUTLINES_BY_FILTER = gql`
  query getCourseOutlinesByFilter(
    $courseOutlineFilterInput: CourseOutlineFilterInput
#    degreeId: ID
#    subjectGroupId: ID
#    subjectId: ID
#    subjectCode: String
#    teacherId: ID
#    teacherCode: String
  )
  {
    getCourseOutlinesByFilter (
      courseOutlineFilterInput: $courseOutlineFilterInput
    )
    {
      id subjectCode teacherCode totalPoint instruction streamIntroPath bookName1 picturePath verticalPicturePath
      bookPic1 bookDescription1 bookName2 bookPic2 bookDescription2 bookName3 bookPic3 bookDescription3
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng creditCalGrade creditDesc
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      courseOutlineUnits {
        id
        seq nameLocal nameEng descriptionLocal descriptionEng preTestExpectScore
        postTestExpectScore unitAgenda unitObjective unitReference
      }
      courseOutlineAssessments {
        id seq percent score
        assessment{
          id nameLocal nameEng
        }
      }
      vdoSets {
        id code description totalVdoLength code
        vdoSetUnits{
          id
          vdoSetTopics { id vdoStreamPath playbackUrl playbackStatus videoProvider bunnyVideoGuid bunnyStatus }
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const GET_COURSEOUTLINEUNITS_BY_COURSEOUTLINEID = gql`
  query getCourseOutlineUnitsByCourseOutlineId(
    $courseOutlineId: ID!
  )
  {
    getCourseOutlineUnitsByCourseOutlineId (
      courseOutlineId: $courseOutlineId
    )
    {
      id seq nameLocal nameEng descriptionLocal descriptionEng
    }
  }
`;

export const GET_COURSEOUTLINES_BY_FILTER_FOR_TABLE = gql`
  query getCourseOutlinesByFilter(
    $courseOutlineFilterInput: CourseOutlineFilterInput
  )
  {
    getCourseOutlinesByFilter (
      courseOutlineFilterInput: $courseOutlineFilterInput
    )
    {
      id
      subject {
        id code nameLocal nameEng creditCalGrade
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      courseOutlineUnits {
        id
      }
      vdoSets {
        id
        #        totalVdoLength
        #        vdoSetUnits{
        #          id
        #          vdoSetTopics { id vdoStreamPath }
        #        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const GET_COURSEOUTLINES_AVAILABLE = gql`
  query getCourseOutlinesAvailable(
    $subjectId: ID!,
    $teacherId: ID!,
    $academicPeriodId: ID!
  )
  {
    getCourseOutlinesAvailable (
      subjectId: $subjectId
      teacherId: $teacherId
      academicPeriodId: $academicPeriodId
    )
    {
      id
      teacher {
        ...TeacherNameFields
        picturePath
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const ADD_COURSEOUTLINE = gql`
  mutation addCourseOutline(
    $degreeId: ID!,
    $subjectGroupId: ID!,
    $subjectId: ID!,
    $subjectCode: String!,
    $teacherId: ID!,
    $teacherCode: String!
  ) {
    addCourseOutline (
      degreeId: $degreeId,
      subjectGroupId: $subjectGroupId,
      subjectId: $subjectId,
      subjectCode: $subjectCode,
      teacherId: $teacherId,
      teacherCode: $teacherCode
    ) {
      id subjectCode teacherCode totalPoint instruction streamIntroPath bookName1 picturePath verticalPicturePath
      bookPic1 bookDescription1 bookName2 bookPic2 bookDescription2 bookName3 bookPic3 bookDescription3
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      courseOutlineUnits {
        id seq nameLocal nameEng descriptionLocal descriptionEng preTestExpectScore
        postTestExpectScore unitAgenda unitObjective unitReference
      }
      courseOutlineAssessments {
        id seq percent score
        assessment{
          id nameLocal nameEng
        }
      }
      vdoSets {
        id code description totalVdoLength
        vdoSetUnits {
          id unitSeq code totalVdoLength status remark
          vdoSetTopics {
            id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark
            playbackUrl
            playbackStatus
            videoProvider
            bunnyVideoGuid
            bunnyStatus
          }
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const UPDATE_COURSEOUTLINE = gql`
  mutation updateCourseOutline(
    $id: ID!,
    $courseOutlineInput: CourseOutlineInput!
  ) {
    updateCourseOutline (
      id: $id,
      courseOutlineInput: $courseOutlineInput,
    ) {
      id subjectCode teacherCode totalPoint instruction streamIntroPath bookName1 picturePath verticalPicturePath
      bookPic1 bookDescription1 bookName2 bookPic2 bookDescription2 bookName3 bookPic3 bookDescription3
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      courseOutlineUnits {
        id seq nameLocal nameEng descriptionLocal descriptionEng preTestExpectScore
        postTestExpectScore unitAgenda unitObjective unitReference
      }
      courseOutlineAssessments {
        id seq percent score
        assessment{
          id nameLocal nameEng
        }
      }
      vdoSets {
        id code description totalVdoLength
        vdoSetUnits {
          id unitSeq code totalVdoLength status remark
          vdoSetTopics {
            id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark
            playbackUrl
            playbackStatus
            videoProvider
            bunnyVideoGuid
            bunnyStatus
          }
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const DELETE_COURSEOUTLINE = gql`
  mutation deleteCourseOutline(
    $id: ID!
  ) {
    deleteCourseOutline (
      id: $id
    ) {
      id subjectCode teacherCode totalPoint instruction streamIntroPath bookName1
      bookPic1 bookDescription1 bookName2 bookPic2 bookDescription2 bookName3 bookPic3 bookDescription3
      degree {
        id code nameLocal nameEng
      }
      subjectGroup {
        id code nameLocal nameEng
      }
      subject {
        id code nameLocal nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      courseOutlineUnits {
        id seq nameLocal nameEng descriptionLocal descriptionEng preTestExpectScore
        postTestExpectScore unitAgenda unitObjective unitReference
      }
      courseOutlineAssessments {
        id seq percent score
        assessment{
          id nameLocal nameEng
        }
      }
      vdoSets {
        id code description totalVdoLength
        vdoSetUnits {
          id unitSeq code totalVdoLength status remark
          vdoSetTopics {
            id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark
            playbackUrl
            playbackStatus
            videoProvider
            bunnyVideoGuid
            bunnyStatus
          }
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;


/* TYPES

input CourseOutlineFilterInput {
    degreeId:         ID
    subjectGroupId:   ID
    subjectId:        ID
    subjectCode:      String
    teacherId:        ID
    teacherCode:      String
}

input CourseOutlineInput {
    totalPoint:       Int
    instruction:      String
    streamIntroPath:  String
    bookName1:        String
    bookPic1:         String
    bookDescription1: String
    bookName2:        String
    bookPic2:         String
    bookDescription2: String
    bookName3:        String
    bookPic3:         String
    bookDescription3: String
}

type CourseOutline {
    id:               ID!
    degree:           Degree!
    subjectGroup:     SubjectGroup!
    subject:          Subject!
    subjectCode:      String!
    teacher:          Teacher!
    teacherCode:      String!
    totalPoint:       Int
    instruction:      String
    streamIntroPath:  String
    bookName1:        String
    bookPic1:         String
    bookDescription1: String
    bookName2:        String
    bookPic2:         String
    bookDescription2: String
    bookName3:        String
    bookPic3:         String
    bookDescription3: String
    courseOutlineUnits:         [CourseOutlineUnit]
    courseOutlineAssessments:   [CourseOutlineAssessment]
    isDisabled:       Boolean!
    createdAt:        String!
    updatedAt:        String!
    createdBy:        User
    updatedBy:        User
}

*/
